export default __webpack_public_path__ + "static/media/moog synth_1.8ff3f355.wav";